import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  AnalysisReportLoading: false,
  AnalysisReportData: '',
  AnalysisReportError: null,
  FinancialReportLoading: false,
  FinancialReportData: '',
  FinancialReportError: null,
}

export const reportReducerSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setAnalysisReportLoading: (state) => {
      state.AnalysisReportLoading = true;
      state.AnalysisReportData = null;
      state.AnalysisReportError = '';
    },
    setAnalysisReportData: (state, action) => {
      state.AnalysisReportLoading = false;
      state.AnalysisReportData = action.payload;
      state.AnalysisReportError = '';
    },
    setAnalysisReportError: (state, action) => {
      state.AnalysisReportLoading = false;
      state.AnalysisReportData = null;
      state.AnalysisReportError = action.payload;
    }, 
    resetAnalysisReportData: (state) => {
      state.AnalysisReportLoading = false;
      state.AnalysisReportData = null;
      state.AnalysisReportError = '';
    },
    setFinancialReportLoading: (state) => {
      state.FinancialReportLoading = true;
      state.FinancialReportData = null;
      state.FinancialReportError = '';
    },
    setFinancialReportData: (state, action) => {
      state.FinancialReportLoading = false;
      state.FinancialReportData = action.payload;
      state.FinancialReportError = '';
    },
    setFinancialReportError: (state, action) => {
      state.FinancialReportLoading = false;
      state.FinancialReportData = null;
      state.FinancialReportError = action.payload;
    }, 
    resetFinancialReportData: (state) => {
      state.FinancialReportLoading = false;
      state.FinancialReportData = null;
      state.FinancialReportError = '';
    }

  },
})

// Action creators are generated for each case reducer function
export const { setAnalysisReportLoading,  setAnalysisReportData, setAnalysisReportError,
  resetAnalysisReportData,setFinancialReportLoading,  setFinancialReportData, setFinancialReportError,
  resetFinancialReportData} = reportReducerSlice.actions

export default reportReducerSlice.reducer;